import { Injectable } from '@angular/core';
import { DataTaskService } from '../core/services/data-task.service';

@Injectable({
  providedIn: 'root'
})
export class SpecialCustProdCalcService {
    constructor(private datatask: DataTaskService) { }

    /**
    * Retrieves list of items.
    *
    * @datatask 296
    * @datataskName sp_ws_p2_special_vp_cust_calc_list
    * @returns promise containing list of functions.
    */
    public async listProducts(): Promise<ProductItem[]> {
        return (await this.datatask.Post(296));
    }

    /**
    * Retrieves get.
    *
    * @datatask 297
    * @datataskName sp_ws_p2_special_vp_cust_calc_get
    * @param params settings for the get to retrieve.
    * @returns promise containing get of functions.
    */
    public async getCalculation(params: GetCalculationParams): Promise<CalculationGet> {
        return (await this.datatask.Post(297, params))[0];
    }

    /**
    * Retrieves list of items.
    *
    * @datatask 298
    * @datataskName sp_ws_p2_special_vp_calc_customers_get
    * @param params settings for the list to retrieve.
    * @returns promise containing list of functions.
    */
    public async listPrices(params: ListPricesParams): Promise<PriceItem[]> {
        return (await this.datatask.Post(298, params));
    }
}

export interface GetSpecialCustProdCalcParams {
    cust_no: string;
}

export interface ProductItem {
    prod_id: string;
    prod_name: string;
    orderby: number;
}

export interface GetCalculationParams {
    cust_no: string | number;
    prod_id: string;
}

export interface CalculationGet {
    price: string;
    discount: string;
    sold_freight: string;
    bonus: string;
    weight: string;
    price_pr_kg_label: string;
    postplace_id: string;
}

export interface ListPricesParams {
    cust_no: string;
    prod_id: string;
    price: string | number;
    discount: string | number;
    bonus: string | number;
    sold_freight: string | number;
    weight: string | number;
    postplace_id: string | number;
}

export interface PriceItem {
    company_name: string;
    frakt_pr_m3: string;
    price_with_discount: string;
    price_after_bonus: string;
    price_real_freight: string;
    price_pr_kilo: string;
}
